import React, { useState, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { IoMdClose } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = useCallback(() => {
    setIsMobileMenuOpen((prev) => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMobileMenuOpen(false);
  }, []);

  const navLinks = [
    { path: "/", name: "Home" },
    { path: "/services", name: "What We Do" },
    { path: "/membership", name: "Membership Plans" },
    { path: "/about", name: "About Us" },
    { path: "/partners", name: "Areas Covered" },
    { path: "/blogs", name: "Blogs / Media" },
    { path: "/contact", name: "Contact Us" },
  ];

  return (
    <nav
      className="bg-white shadow-lg fixed w-full top-0 z-50"
      role="navigation"
      aria-label="Main Navigation"
    >
      {/* Top Row */}
      <div className="w-full my-1 mx-auto sm:px-4 lg:px-4 h-16 flex justify-between items-center px-4">
        {/* Branding */}
        <NavLink
          to="/"
          aria-label="Go to Home Page"
          className="flex items-center"
        >
          <img
            src="/ImageAndVideo/logo/withoutbg.png"
            alt="Logo"
            className="h-20  sm:h-18 lg:h-20 w-auto object-contain"
          />
          {/* Brand Name + Tagline */}
          <div className="flex flex-col leading-tight -ml-3">
            <span className="text-maroon font-bold text-lg sm:text-xl lg:text-2xl">
              Aegiscare
            </span>
            <span className="text-xs sm:text-sm text-gray-500 italic">
            Care we Trust
            </span>
          </div>
        </NavLink>

        {/* Enroll Now (Desktop) */}
        <div className="hidden md:block">
          <a
            href="/contact"
            className="bg-maroon text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gold"
            aria-label="Enroll now"
          >
            Enroll Now
          </a>
        </div>

        {/* Mobile Menu Button */}
        <div className="block md:hidden">
          <button
            onClick={toggleMobileMenu}
            className="text-maroon hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold rounded-md"
            aria-label="Toggle navigation menu"
            aria-expanded={isMobileMenuOpen}
          >
            {isMobileMenuOpen ? (
              <IoMdClose className="size-6" />
            ) : (
              <RxHamburgerMenu className="size-6" />
            )}
          </button>
        </div>
      </div>

      {/* Desktop Navigation */}
      <div className="hidden md:block bg-maroon-dark py-2 border-t border-maroon-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center space-x-8">
          {navLinks.map(({ path, name }) => (
            <NavLink
              key={name}
              to={path}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium transition-colors duration-300 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-gold rounded-md
                 ${isActive
                  ? "text-gold border-b-2 border-gold"
                  : "text-white hover:text-gold"
                }`
              }
              aria-label={`Go to ${name} page`}
            >
              {name}
            </NavLink>
          ))}
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-maroon-dark pb-3 border-t border-maroon-light animate-fadeIn">
          <div className="px-2 pt-2 space-y-1">
            {navLinks.map(({ path, name }) => (
              <NavLink
                key={name}
                to={path}
                onClick={closeMenu}
                className={({ isActive }) =>
                  `block px-3 py-2 text-base font-medium transition-colors duration-300 rounded-md
                   ${isActive ? "text-gold" : "text-white hover:text-gold"
                  } focus:outline-none focus:ring-2 focus:ring-gold`
                }
                aria-label={`Go to ${name} page`}
              >
                {name}
              </NavLink>
            ))}
            <button
              onClick={() => {
                alert("Enrollment process initiated!");
                closeMenu();
              }}
              className="w-full text-left bg-gold hover:bg-gold-light text-maroon px-3 py-2 rounded font-semibold mt-2 text-base focus:outline-none focus:ring-2 focus:ring-gold"
              aria-label="Enroll now for care services"
            >
              Enroll Now
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
